export default __webpack_public_path__ + "static/media/hair-4-5.13b91014.svg";